// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ezkQ","question":"styles_question__1FwXy","inputVisibleButton":"styles_inputVisibleButton__3_iZG","note":"styles_note__3WEp4"};